<template>
  <div class="">
      <!-- Email -->

      <br />
      <v-card>
        <v-card-title primary-title>
            <div>
              Your email is <b>{{ email }}</b>. We will not share this email but we do use it
              to communicate with you and as your login name.
            </div>
        </v-card-title>

       <v-card-actions>

         <v-spacer></v-spacer>
         <v-btn @click="show = !show" flat color="accent">
           Change Email <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

          </v-btn>
        </v-card-actions>

        <v-slide-y-transition>

          <v-card-text v-show="show">
            We will send a link to your current email to confirm the change for security.
            <v-form width="100px" v-model="valid">

                <v-text-field
                  v-model="newEmail"
                  type="text"
                  :rules="emailRules"
                  label="New Email"
                  required
                ></v-text-field>
                <v-layout row align-center justify-center>
                  <v-btn class="success" @click="submit"  :disabled="!valid" :loading="inprogress" >Submit</v-btn>
                </v-layout>
            </v-form>
            <v-layout row class="heading success--text " v-show="updateSuccess">
              <v-spacer></v-spacer>
              Confirmation email was sent to {{email}}.
              <v-spacer></v-spacer>
            </v-layout>

            <v-layout row class="heading error--text " v-show="errMessage">
              <v-spacer></v-spacer>
              {{errMessage}}
              <v-spacer></v-spacer>
            </v-layout>

          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import utils from '../../../utils.ts'
import config from '../../../config.js'
import firebase from 'firebase/app'

export default {
  name: 'EmailCardLink',
  components: {
  },
  computed: {
    ...mapState({
      name: state => state.admin.userInfo.name,
      locked: state => state.admin.public_settings.locked
    })

  },
  props: {

  },
  mounted: function () {
    this.email = firebase.auth().currentUser.email
  },
  data () {
    return {
      show: false,
      valid: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null,
      password: '',
      newEmail: '',
      email: 'Loading...',
      passwordRules: [
        utils.required('This field is required'),
        utils.minLength(8, 'Password must be at lesat 8 characters long'),
        utils.maxLength(50, 'Password cannot be more than 50 characters long')
      ],
      emailRules: [
        utils.required('This field is required'),
        utils.emailValidation('Email is not valid')
      ]
    }
  },
  methods: {
    submit: async function () {
      // Update the password
      this.inprogress = true
      this.errMessage = null
      this.updateSuccess = false

      if (this.locked) {
        this.errMessage = "Account is locked. You cannot make changes."
        this.inprogress = false
        return
      }

      let url = config.serverLoc+'artists/updateEmail?newemail='+this.newEmail

      // Send a notification to the new parent
      // Admin SDK API to generate the sign in with email link.
      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for
        // this URL must be whitelisted in the Firebase Console.
        url: url,
        // This must be true for email link sign-in.
        handleCodeInApp: true,
        // FDL custom domain.
        // dynamicLinkDomain: config.webDomain
      };

      firebase.auth().sendSignInLinkToEmail(this.email, actionCodeSettings).then(
        () => {
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          window.localStorage.setItem('emailForSignIn', this.email);

          this.updateSuccess = true
        }).catch((err) => {
          console.error("Error sending link: "+err.message)
          this.errMessage = err.message
      })

      this.inprogress = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
